import React from "react";
import { Box } from "@mui/material";

import munafaposter from "../../../assets/images/munafaposter.png";

const MunafaPoster = () => {
  return (
    <Box
      component="img"
      src={munafaposter}
      alt="Munafa Mitra Poster"
      sx={{
        width: "100%",
        borderRadius: 3,
      }}
    />
  );
};

export default MunafaPoster;
